export class PermissionsByRoute {
	private readonly map: Record<string, string[]>;

	constructor(map: Record<string, string[]>) {
		this.map = map;
	}

	get(route: string): string[] {
		return this.map[route] ?? [];
	}

	routes(): string[] {
		return Object.keys(this.map);
	}
}